import colors from './colors';

const fontWeight = {
  bold: 700,
  semiBold: 600,
  regular: 400,
};

const subtitle2 = {
  fontSize: 14,
  fontWeight: fontWeight.regular,
  color: colors.gray1,
  lineHeight: 1.5,
};
const h5 = {
  fontSize: 20,
  fontWeight: fontWeight.bold,
};
const syncIndicatorContent = {
  fontFamily: `Roboto, sans-serif`,
  fontWeight: 400,
};

export default {
  fontWeight,
  subtitle2,
  h5,
  htmlFontSize: 14.5,
  fontFamily: 'Source Sans Pro',
  h4: {
    fontSize: 34,
    fontWeight: fontWeight.bold,
  },
  h4InBar: {
    fontSize: 24,
    fontWeight: fontWeight.semiBold,
  },
  h4Regular: {
    fontSize: 34,
    fontWeight: fontWeight.regular,
  },
  h5Semibold: {
    fontSize: 20,
    fontWeight: fontWeight.semiBold,
  },
  h6: {
    fontSize: 18,
    fontWeight: fontWeight.semiBold,
  },
  body1: {
    fontSize: 16,
    fontWeight: fontWeight.regular,
  },
  body1bold: {
    fontSize: 16,
    fontWeight: fontWeight.bold,
  },
  body2: {
    fontSize: 14,
    fontWeight: fontWeight.regular,
  },
  body2Bold: {
    fontSize: 14,
    fontWeight: fontWeight.bold,
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: fontWeight.regular,
  },
  caption: {
    fontSize: 12,
    fontWeight: fontWeight.regular,
  },
  overline: {
    fontSize: 12,
    fontWeight: fontWeight.regular,
    textTransform: 'uppercase',
  },
  button: {
    lineHeight: null,
    fontSize: 14,
    fontWeight: fontWeight.bold,
  },
  syncIndicatorContent: {
    fontFamily: syncIndicatorContent.fontFamily,
  },
};
